import type { FC, ReactNode } from 'react';

interface MarketingLayoutProps {
  children: ReactNode;
}

const MarketingLayout: FC<MarketingLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <nav className="border-b border-border bg-background">
        <div className="max-w-5xl mx-auto px-4 flex items-center h-14">
          <a className="flex items-center gap-2 text-lg font-bold text-foreground" href="/">
            <img src="/icon-192.png" alt="" className="h-8 w-8 rounded-lg" />
            {import.meta.env.VITE_BRAND_NAME}
          </a>
        </div>
      </nav>

      <main className="grow">
        {children}
      </main>

      <footer className="border-t border-border bg-background py-4 mt-auto">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <small className="text-muted-foreground">&copy; 2025 {import.meta.env.VITE_BRAND_NAME}. All rights reserved.</small>
        </div>
      </footer>
    </div>
  );
};

export default MarketingLayout;
